/* eslint-disable sort-imports */

import Vue from "vue"

/**********/
/* Styles */
/**********/

// https://element.eleme.io/#/en-US/component/installation
import "./plugins/element-ui.js"

// https://animate.style/#usage
import "animate.css/animate.min.css"

// Custom CSS
import "@/styles/main.scss"

/***********/
/* Plugins */
/***********/

// https://vcalendar.io/
import VCalendar from "v-calendar"
Vue.use(VCalendar)

// https://momentjs.com/docs/
import moment from "moment"
moment.locale(config.i18nLocale)
Vue.prototype.$moment = moment

// https://github.com/pusher/pusher-js
import pusher from "./plugins/pusher"
Vue.prototype.$pusher = pusher

// https://vuejs.org/v2/guide/filters.html
import "@/plugins/filters"

/*******/
/* App */
/*******/

import App from "./App.vue"
import config from "@/app.config"
import router from "./router"
import i18n from "./plugins/i18n"
import store from "./store"

// Core API client configuration
import coreApiClient from "@/providers/core-api/CoreApi"
coreApiClient.getAccessToken = () => store.state.auth.token

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app")
